export const FETCH_POWER_BI_REPORTS_REQUEST = 'FETCH_POWER_BI_REPORTS_REQUEST';
export const FETCH_POWER_BI_REPORTS_SUCCESS = 'FETCH_POWER_BI_REPORTS_SUCCESS';
export const FETCH_POWER_BI_REPORTS_FAILURE = 'FETCH_POWER_BI_REPORTS_FAILURE';
